<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>顾问评分规则列表</el-breadcrumb-item>
				</el-breadcrumb>
				<el-button type="success" style="margin-left: 8vh" icon="el-icon-plus" @click="handleNewAdd"
					size="mini">新增评分规则</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="sort" label="排序" align="center" />
			<el-table-column prop="title" label="文章标题" align="center" />
			<el-table-column prop="default_hot_num" label="文章封面" align="center" width="200">
				<template slot-scope="scope">
					<div>
						<template v-if="
                Array.isArray(JSON.parse(scope.row.article_imgs)) &&
                JSON.parse(scope.row.article_imgs).length > 1
              ">
							<el-image v-for="(img, index) in JSON.parse(scope.row.article_imgs)" :key="index"
								style="width: 50px; height: 50px; margin-right: 5px" :src="img"
								:preview-src-list="JSON.parse(scope.row.article_imgs)" />
						</template>
						<template v-else-if="
                Array.isArray(JSON.parse(scope.row.article_imgs)) &&
                JSON.parse(scope.row.article_imgs).length === 1
              ">
							<el-image style="width: 50px; height: 50px; margin-right: 5px"
								:src="JSON.parse(scope.row.article_imgs)[0]"
								:preview-src-list="[JSON.parse(scope.row.article_imgs)[0]]" />
						</template>
						<template v-else>
							<div class="image-slot">
								<span style="line-height: 50px">暂无图片</span>
							</div>
						</template>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="url" label="文章地址" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" style="color: #409eff">{{
            scope.row.url
          }}</a>
				</template>
			</el-table-column>
			<el-table-column prop="default_hot_num" label="初始热度" align="center" />
			<el-table-column prop="hot_num" label="点击热度" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="60%"
			 :before-close="getout"
			:append-to-body="true" top="5vh">
			<el-table :data="tableData" :span-method="objectSpanMethod" @cell-click="handleCellClick" border
				style="width: 100%;" :max-height="dmaxHeight">
				<el-table-column prop="ruleName" label="维度" width="180">
				</el-table-column>
				<el-table-column prop="score" label="分值" align="center">
				</el-table-column>
				<el-table-column prop="sruleName" label="标签组">
				</el-table-column>
				<el-table-column prop="sscore" label="权重" align="center">
				</el-table-column>
				<el-table-column prop="ssruleName" label="子标签">
				</el-table-column>
				<el-table-column prop="ssscore" label="权重" align="center">
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		Row
	} from "element-ui";
	import tableCommon from "../../../mixins/table-common";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 规则验证
				rules: {
					category_ids: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}, ],
					title: [{
						required: true,
						message: "请输入名称",
						trigger: "blur"
					}],
					status: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
				},
				// 请求地址api
				api: {
					list: function() {
						return {
							total: 0,
							records: []
						}
					},
				},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				initLoad: false,
				dmaxHeight: 0,
				showEdit: [],
				tableData: [],
				rowcolSpans: [],
				data: {
					"calculateParams": "",
					"calculateType": "",
					"createTime": 1726214098000,
					"id": 1,
					"pRuleId": 0,
					"ruleDomainName": "客户评分",
					"ruleDomainType": "member_score",
					"ruleName": "客户评分",
					"ruleType": "member_score",
					"score": 100.00,
					"scoreRatio": 1.00,
					"subConfigs": [{
							"calculateParams": "",
							"calculateType": "",
							"createTime": 1726214311000,
							"id": 2,
							"pRuleId": 1,
							"ruleDomainName": "",
							"ruleDomainType": "",
							"ruleName": "客户标签",
							"ruleType": "member_tag",
							"score": 20.00,
							"scoreRatio": 0.20,
							"subConfigs": [{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726214617000,
									"id": 5,
									"pRuleId": 2,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "房屋状态",
									"ruleType": "room_status",
									"score": 4.00,
									"scoreRatio": 0.20,
									"subConfigs": [{
											"calculateParams": "34",
											"calculateType": "other_tag",
											"createTime": 1726279523000,
											"id": 22,
											"pRuleId": 5,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "房屋自住",
											"ruleType": "room_live_self",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "10",
											"calculateType": "other_tag",
											"createTime": 1726279523000,
											"id": 23,
											"pRuleId": 5,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "房屋出租",
											"ruleType": "room_lease",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "12",
											"calculateType": "other_tag",
											"createTime": 1726279523000,
											"id": 24,
											"pRuleId": 5,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "房屋待售",
											"ruleType": "room_saleing",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "11",
											"calculateType": "other_tag",
											"createTime": 1726279523000,
											"id": 25,
											"pRuleId": 5,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "房屋已售",
											"ruleType": "room_saled",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 5.00
										}
									],
									"updateTime": 1726214617000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215575000,
									"id": 6,
									"pRuleId": 2,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "入住情况",
									"ruleType": "live_status",
									"score": 2.40,
									"scoreRatio": 0.12,
									"subConfigs": [{
											"calculateParams": "33",
											"calculateType": "other_tag",
											"createTime": 1726281012000,
											"id": 26,
											"pRuleId": 6,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "长住",
											"ruleType": "offen_live",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "7",
											"calculateType": "other_tag",
											"createTime": 1726281012000,
											"id": 27,
											"pRuleId": 6,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "很少住",
											"ruleType": "less_live",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "17",
											"calculateType": "other_tag",
											"createTime": 1726281012000,
											"id": 28,
											"pRuleId": 6,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "老人住",
											"ruleType": "old_live",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 3.00
										},
										{
											"calculateParams": "126",
											"calculateType": "other_tag",
											"createTime": 1726281012000,
											"id": 29,
											"pRuleId": 6,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "子女住",
											"ruleType": "child_live",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 8.00
										}
									],
									"updateTime": 1726215575000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215650000,
									"id": 7,
									"pRuleId": 2,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "装修情况",
									"ruleType": "renovation",
									"score": 1.60,
									"scoreRatio": 0.08,
									"subConfigs": [{
											"calculateParams": "117",
											"calculateType": "other_tag",
											"createTime": 1726281257000,
											"id": 30,
											"pRuleId": 7,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "已装修",
											"ruleType": "renovationed",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "116",
											"calculateType": "other_tag",
											"createTime": 1726281257000,
											"id": 31,
											"pRuleId": 7,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "装修中",
											"ruleType": "renovationing",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "115",
											"calculateType": "other_tag",
											"createTime": 1726281257000,
											"id": 32,
											"pRuleId": 7,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "未装修",
											"ruleType": "no_renovation",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 0.00
										}
									],
									"updateTime": 1726215650000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215723000,
									"id": 8,
									"pRuleId": 2,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "有无车辆",
									"ruleType": "car_count",
									"score": 6.00,
									"scoreRatio": 0.30,
									"subConfigs": [{
											"calculateParams": "121",
											"calculateType": "other_tag",
											"createTime": 1726281517000,
											"id": 33,
											"pRuleId": 8,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有3辆车以上",
											"ruleType": "more_three_car",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284715000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "20",
											"calculateType": "other_tag",
											"createTime": 1726281517000,
											"id": 34,
											"pRuleId": 8,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有2辆车",
											"ruleType": "two_car",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "19",
											"calculateType": "other_tag",
											"createTime": 1726281517000,
											"id": 35,
											"pRuleId": 8,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有1辆车",
											"ruleType": "one_car",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "9",
											"calculateType": "other_tag",
											"createTime": 1726281517000,
											"id": 36,
											"pRuleId": 8,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "没有车",
											"ruleType": "no_car",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 0.00
										}
									],
									"updateTime": 1726215723000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215769000,
									"id": 9,
									"pRuleId": 2,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "有无车位",
									"ruleType": "carport_count",
									"score": 6.00,
									"scoreRatio": 0.30,
									"subConfigs": [{
											"calculateParams": "13",
											"calculateType": "other_tag",
											"createTime": 1726281652000,
											"id": 37,
											"pRuleId": 9,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有1个车位",
											"ruleType": "onr_carport",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 0.00
										},
										{
											"calculateParams": "35",
											"calculateType": "other_tag",
											"createTime": 1726281652000,
											"id": 38,
											"pRuleId": 9,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有2个车位",
											"ruleType": "two_carport",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 0.00
										},
										{
											"calculateParams": "122",
											"calculateType": "other_tag",
											"createTime": 1726281652000,
											"id": 39,
											"pRuleId": 9,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "有3个车位以上",
											"ruleType": "three_carport",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 0.00
										},
										{
											"calculateParams": "123",
											"calculateType": "other_tag",
											"createTime": 1726281652000,
											"id": 40,
											"pRuleId": 9,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "没有车位",
											"ruleType": "no_carport",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284716000,
											"version": "1.0",
											"weight": 5.00
										}
									],
									"updateTime": 1726215769000,
									"version": "1.0",
									"weight": 0.00
								}
							],
							"updateTime": 1726214311000,
							"version": "1.0",
							"weight": 0.00
						},
						{
							"calculateParams": "",
							"calculateType": "",
							"createTime": 1726214413000,
							"id": 3,
							"pRuleId": 1,
							"ruleDomainName": "",
							"ruleDomainType": "",
							"ruleName": "客户行为",
							"ruleType": "member_action",
							"score": 50.00,
							"scoreRatio": 0.50,
							"subConfigs": [{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215930000,
									"id": 10,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "用户来源",
									"ruleType": "mem_from",
									"score": 1.50,
									"scoreRatio": 0.03,
									"subConfigs": [{
											"calculateParams": "2",
											"calculateType": "from_type",
											"createTime": 1726281964000,
											"id": 41,
											"pRuleId": 10,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "扫码",
											"ruleType": "scan_qr",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726285235000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "3",
											"calculateType": "from_type",
											"createTime": 1726281964000,
											"id": 42,
											"pRuleId": 10,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "单聊分享",
											"ruleType": "chat_alone",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726285235000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "4",
											"calculateType": "from_type",
											"createTime": 1726281964000,
											"id": 43,
											"pRuleId": 10,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "群聊分享",
											"ruleType": "chat_group",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726285235000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "8",
											"calculateType": "from_type",
											"createTime": 1726281964000,
											"id": 44,
											"pRuleId": 10,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "短链",
											"ruleType": "shot_link",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726285235000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726215930000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726215980000,
									"id": 11,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "累计访问次数",
									"ruleType": "visit_times",
									"score": 2.50,
									"scoreRatio": 0.05,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "visit_times",
											"createTime": 1726282385000,
											"id": 45,
											"pRuleId": 11,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1次",
											"ruleType": "one_times",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 3.00
										},
										{
											"calculateParams": "2-10",
											"calculateType": "visit_times",
											"createTime": 1726282385000,
											"id": 46,
											"pRuleId": 11,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "2-10次",
											"ruleType": "2-10_times",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "11-20",
											"calculateType": "visit_times",
											"createTime": 1726282385000,
											"id": 47,
											"pRuleId": 11,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "11-20次",
											"ruleType": "11-20_times",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "21",
											"calculateType": "visit_times",
											"createTime": 1726282385000,
											"id": 48,
											"pRuleId": 11,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "21次及以上",
											"ruleType": "21_times_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216119000,
									"id": 12,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "累计访问时长",
									"ruleType": "visit_duration",
									"score": 3.50,
									"scoreRatio": 0.07,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "visit_time",
											"createTime": 1726283310000,
											"id": 49,
											"pRuleId": 12,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1-60秒",
											"ruleType": "0-1min",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 3.00
										},
										{
											"calculateParams": "1-10",
											"calculateType": "visit_time",
											"createTime": 1726283310000,
											"id": 50,
											"pRuleId": 12,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "61秒-10分钟",
											"ruleType": "1-10min",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "11-20",
											"calculateType": "visit_time",
											"createTime": 1726283310000,
											"id": 51,
											"pRuleId": 12,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "11-20分钟",
											"ruleType": "11-20min",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "21",
											"calculateType": "visit_time",
											"createTime": 1726283310000,
											"id": 52,
											"pRuleId": 12,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "21分钟以上",
											"ruleType": "21min_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726283480000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216206000,
									"id": 13,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "客户活跃",
									"ruleType": "mem_active",
									"score": 5.00,
									"scoreRatio": 0.10,
									"subConfigs": [{
											"calculateParams": "1/7",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 53,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近7天内来访1天",
											"ruleType": "1/7_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "2/7",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 54,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近7天内来访2天",
											"ruleType": "2/7_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "3/7",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 55,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近7天内来访3天以上",
											"ruleType": "3/7_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "0/7",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 56,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近7天未来访",
											"ruleType": "0/7_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 0.00
										},
										{
											"calculateParams": "0/15",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 57,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近15天未来访",
											"ruleType": "0/15_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 0.00
										},
										{
											"calculateParams": "0/30",
											"calculateType": "activation",
											"createTime": 1726283703000,
											"id": 58,
											"pRuleId": 13,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "近30天未来访",
											"ruleType": "0/30_visit",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 0.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216262000,
									"id": 14,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "浏览车位数量",
									"ruleType": "visit_carport_count",
									"score": 5.00,
									"scoreRatio": 0.10,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "carport_visit",
											"createTime": 1726284021000,
											"id": 59,
											"pRuleId": 14,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1个",
											"ruleType": "one",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "2",
											"calculateType": "carport_visit",
											"createTime": 1726284021000,
											"id": 60,
											"pRuleId": 14,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "2个及以上",
											"ruleType": "two_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216312000,
									"id": 15,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "收藏车位数量",
									"ruleType": "sc_carport_count",
									"score": 7.50,
									"scoreRatio": 0.15,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "carport_sc",
											"createTime": 1726284077000,
											"id": 61,
											"pRuleId": 15,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1个",
											"ruleType": "one",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "2",
											"calculateType": "carport_sc",
											"createTime": 1726284077000,
											"id": 62,
											"pRuleId": 15,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "2个及以上",
											"ruleType": "two_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216506000,
									"id": 16,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "锁定车位数量",
									"ruleType": "lock_carport_count",
									"score": 15.00,
									"scoreRatio": 0.30,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "carport_lock",
											"createTime": 1726284123000,
											"id": 63,
											"pRuleId": 16,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1个",
											"ruleType": "one",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 8.00
										},
										{
											"calculateParams": "2",
											"calculateType": "carport_lock",
											"createTime": 1726284123000,
											"id": 64,
											"pRuleId": 16,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "2个及以上",
											"ruleType": "two_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284939000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216506000,
									"id": 17,
									"pRuleId": 3,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "分享车位次数",
									"ruleType": "share_carport_count",
									"score": 10.00,
									"scoreRatio": 0.20,
									"subConfigs": [{
											"calculateParams": "0-1",
											"calculateType": "carport_share",
											"createTime": 1726284156000,
											"id": 65,
											"pRuleId": 17,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "1个",
											"ruleType": "one",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "2",
											"calculateType": "carport_share",
											"createTime": 1726284156000,
											"id": 66,
											"pRuleId": 17,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "2个及以上",
											"ruleType": "two_more",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 10.00
										}
									],
									"updateTime": 1726216579000,
									"version": "1.0",
									"weight": 0.00
								}
							],
							"updateTime": 1726214413000,
							"version": "1.0",
							"weight": 0.00
						},
						{
							"calculateParams": "",
							"calculateType": "",
							"createTime": 1726214459000,
							"id": 4,
							"pRuleId": 1,
							"ruleDomainName": "",
							"ruleDomainType": "",
							"ruleName": "顾问判断",
							"ruleType": "staff_judge",
							"score": 30.00,
							"scoreRatio": 0.30,
							"subConfigs": [{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216634000,
									"id": 18,
									"pRuleId": 4,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "跟进计划",
									"ruleType": "follow_up_plan",
									"score": 6.00,
									"scoreRatio": 0.20,
									"subConfigs": [{
											"calculateParams": "1",
											"calculateType": "follow_plan_tag",
											"createTime": 1726284209000,
											"id": 67,
											"pRuleId": 18,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "重点跟进",
											"ruleType": "key_followup",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "2",
											"calculateType": "follow_plan_tag",
											"createTime": 1726284209000,
											"id": 68,
											"pRuleId": 18,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "正常跟进",
											"ruleType": "common_followup",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 5.00
										},
										{
											"calculateParams": "3",
											"calculateType": "follow_plan_tag",
											"createTime": 1726284209000,
											"id": 69,
											"pRuleId": 18,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "不跟进",
											"ruleType": "not_followup",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726284938000,
											"version": "1.0",
											"weight": 0.00
										}
									],
									"updateTime": 1726216761000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216715000,
									"id": 20,
									"pRuleId": 4,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "加微情况",
									"ruleType": "wechat_add",
									"score": 9.00,
									"scoreRatio": 0.30,
									"subConfigs": [{
											"calculateParams": "120",
											"calculateType": "other_tag",
											"createTime": 1726284461000,
											"id": 70,
											"pRuleId": 20,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "主动加微信",
											"ruleType": "active_wechat",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726302455000,
											"version": "1.0",
											"weight": 10.00
										},
										{
											"calculateParams": "36",
											"calculateType": "other_tag",
											"createTime": 1726284461000,
											"id": 71,
											"pRuleId": 20,
											"ruleDomainName": "",
											"ruleDomainType": "",
											"ruleName": "被动加微信",
											"ruleType": "passive_wechat",
											"score": 0.00,
											"scoreRatio": 0.00,
											"updateTime": 1726302455000,
											"version": "1.0",
											"weight": 8.00
										}
									],
									"updateTime": 1726216762000,
									"version": "1.0",
									"weight": 0.00
								},
								{
									"calculateParams": "",
									"calculateType": "",
									"createTime": 1726216755000,
									"id": 21,
									"pRuleId": 4,
									"ruleDomainName": "",
									"ruleDomainType": "",
									"ruleName": "带看情况",
									"ruleType": "take_look",
									"score": 15.00,
									"scoreRatio": 0.50,
									"subConfigs": [{
										"calculateParams": "3",
										"calculateType": "stage_type",
										"createTime": 1726284627000,
										"id": 72,
										"pRuleId": 21,
										"ruleDomainName": "",
										"ruleDomainType": "",
										"ruleName": "带看",
										"ruleType": "take_look",
										"score": 0.00,
										"scoreRatio": 0.00,
										"updateTime": 1726302455000,
										"version": "1.0",
										"weight": 10.00
									}],
									"updateTime": 1726216761000,
									"version": "1.0",
									"weight": 0.00
								}
							],
							"updateTime": 1726214459000,
							"version": "1.0",
							"weight": 0.00
						}
					],
					"updateTime": 1726214098000,
					"version": "1.0",
					"weight": 0.00
				}
			};
		},
		mounted() {
			this.dmaxHeight = window.innerHeight * 0.70;
		},
		methods: {
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				let rowspan = this.rowcolSpans[columnIndex][rowIndex];
				let colspan = rowspan > 0 ? 1 : 0;

				return {
					rowspan: rowspan,
					colspan: colspan
				};
			},
			handleCellClick(row, col, cell, event) {
				console.log('=====================:', row, col, cell, event);
				let that = this;
				if (event.target.innerText.length > 0 && (col.label == '分值' || col.label == '权重')) {
					event.target.innerText = "";
					let cellInput = document.createElement("input");
					cellInput.value = row[col.property];
					cellInput.setAttribute("type", "text");
					cellInput.style.width = "70%";
					cellInput.style.marginLeft = "10px";
					cellInput.style.paddingLeft = "5px";
					cell.appendChild(cellInput);
					//   聚焦
					cellInput.focus();
					//失焦事件
					cellInput.onblur = function() {
						cell.removeChild(cellInput);
						event.target.innerText = cellInput.value;
						row[col.property] = cellInput.value;
						console.log('====================:',that.tableData)
					};
				}
				
			},
			// 改变状态
			changeStatus(res) {

			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.handleAdd();

				setTimeout(() => {
					var tableData = [];

					var rows0 = [],
						rows1 = [],
						rows2 = [];
					this.data.subConfigs.forEach((item, index) => {
						var row = 0;
						item.subConfigs.forEach((sitem, sindex) => {
							sitem.subConfigs.forEach((ssitem, ssindex) => {
								var tableItem = {}
								tableItem.id = item.id;
								tableItem.ruleName = item.ruleName;
								tableItem.score = item.score;

								row++;

								tableItem.sid = sitem.id;
								tableItem.sruleName = sitem.ruleName;
								tableItem.sscore = sitem.score;

								tableItem.ssid = ssitem.id;
								tableItem.ssruleName = ssitem.ruleName;
								tableItem.ssscore = ssitem.weight;

								rows2.push(1);

								tableData.push(tableItem);
							})
							rows1.push(sitem.subConfigs.length);
						})

						rows0.push(row);
					})

					var row_0 = [];
					for (var i = 0; i < rows0.length; i++) {
						for (var j = 0; j < rows0[i]; j++) {
							if (j == 0) {
								row_0.push(rows0[i]);
							} else {
								row_0.push(0);
							}
						}
					}

					var row_1 = [];
					for (var i = 0; i < rows1.length; i++) {
						for (var j = 0; j < rows1[i]; j++) {
							if (j == 0) {
								row_1.push(rows1[i]);
							} else {
								row_1.push(0);
							}
						}
					}

					this.rowcolSpans = [row_0, row_0, row_1, row_1, rows2, rows2];
					this.tableData = tableData;
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.handleEdit();
			},
			// 点击确定
			submitForms() {

			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
			},
		},
	};
</script>

<style scoped>
	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/ruleEngine/salorRule.vue